import React from 'react'
import {useTranslation} from 'react-i18next'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'

const Option = styled.span`
  &:hover {
    color: var(--bs-primary);
  }

`

const TourTypesFilter = (props) => {
  const {productTypes, productScheduleTypes, machine} = props
  const [current, send] = machine
  const {i18n} = useTranslation()

  const availableTourTypes = [
    { label: i18n.t('tour_types_filter.regular_group'), value: 'regular_group' },
    { label: i18n.t('tour_types_filter.small_group'), value: 'small_group' },
    { label: i18n.t('tour_types_filter.private_group'), value: 'private_group' },
    // { label: i18n.t('tour_types_filter.tailor_made'), value: 'tailor_made' },
    { label: i18n.t('tour_types_filter.hop_on_hop_off'), value: 'hop_on_hop_off' },
    { label: i18n.t('tour_types_filter.self_guided'), value: 'self_guided' }
  ]

  const tourTypes = availableTourTypes.filter(({value}) => productTypes.includes(value))

  const availableTourScheduleTypes = [
    { label: i18n.t('tour_schedule_types_filter.morning'), value: 'morning' },
    { label: i18n.t('tour_schedule_types_filter.afternoon'), value: 'afternoon' },
    { label: i18n.t('tour_schedule_types_filter.night'), value: 'night' },
    { label: i18n.t('tour_schedule_types_filter.full_day'), value: 'full_day' },
    { label: i18n.t('tour_schedule_types_filter.multi_day'), value: 'multi_day' }
  ]

  const tourScheduleTypes = availableTourScheduleTypes.filter(({value}) => productScheduleTypes.includes(value))

  const tourTypeFilterd = current.context.filters.find(
    (filter) => filter.param === 'tour_type'
  )
  const tourTypeFilterValue = tourTypeFilterd && tourTypeFilterd.value

  const onTourTypeFilter = (tourType) => {
    if (tourTypeFilterValue === tourType.value) {
      send({ type: 'FILTER_REMOVE', param: 'tour_type' })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: 'tour_type',
          label: tourType.label,
          value: tourType.value
        }
      })
    }

    if (isMobile) {
      props.setIsOpen(!props.isOpen)
    }
  }

  const tourScheduleTypeFilterd = current.context.filters.find(
    (filter) => filter.param === 'tour_schedule_type'
  )
  const tourScheduleTypeFilterValue = tourScheduleTypeFilterd && tourScheduleTypeFilterd.value

  const onTourScheduleTypeFilter = (tourScheduleType) => {
    if (tourScheduleTypeFilterValue === tourScheduleType.value) {
      send({ type: 'FILTER_REMOVE', param: 'tour_schedule_type' })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: 'tour_schedule_type',
          label: tourScheduleType.label,
          value: tourScheduleType.value
        }
      })
    }

    if (isMobile) {
      props.setIsOpen(!props.isOpen)
    }
  }

  return (
    <>
      {tourTypes.map((tourType) => (
        <div key={tourType.value} className="mb-1">
          <input
            type="radio"
            className="me-2"
            checked={tourType.value === tourTypeFilterValue}
            onChange={() => onTourTypeFilter(tourType)}
            style={{ cursor: 'pointer' }}
          />
          <label
            onClick={() => onTourTypeFilter(tourType)}
            style={{ cursor: 'pointer' }}
          >
            <Option className={tourType.value === tourTypeFilterValue ? 'fw-semibold' : 'fw-normal'}>{tourType.label}</Option>
          </label>
        </div>
      ))}

      {tourScheduleTypes && tourScheduleTypes.length > 0 &&
        <>
          <hr/>

          {tourScheduleTypes.map((tourScheduleType) => (
            <div key={tourScheduleType.value} className="mb-1">
              <input
                type="radio"
                className="me-2"
                checked={tourScheduleType.value === tourScheduleTypeFilterValue}
                onChange={() => onTourScheduleTypeFilter(tourScheduleType)}
                style={{ cursor: 'pointer' }}
              />
              <label
                onClick={() => onTourScheduleTypeFilter(tourScheduleType)}
                style={{ cursor: 'pointer' }}
              >
                <Option className={tourScheduleType.value === tourScheduleTypeFilterValue ? 'fw-semibold' : 'fw-normal'}>{tourScheduleType.label}</Option>
              </label>
            </div>
          ))}
        </>
      }
    </>
  )
}

export default TourTypesFilter
